import { useEffect, useMemo, useState } from "react";
import LumpIcon from "../../icons/lump.icon";
import { Form, Spinner } from "react-bootstrap";
import "./index.styles.scss";
import cn from "../../../Utils/class-names.utils";

const ReviewMoreToolsTooltip = ({ 
  showTooltip, 
  selected=[],
  delay, 
  setShowTooltip = () => {}, 
  techModalData, 
  integration,
  className = '',
  onAddSuccess = () => { },
  onClose = () => { },
}) => {
  const [isAdding, setIsAdding] = useState(false);
  // const { createMultipleIntegrationTechTool } = useApiActions();
  const [isReviewing, setIsReviewing] = useState(false);
  const [selectedTechnologies, setSelectedTechnologies] = useState([]);
  const list = useMemo(() => techModalData?.map(item => ({
    label: item?.IntegrationTechnologyTypeName,
    enum: item?.IntegrationTechnologyTypeEnum,
    inYourStack: item?.ExistsInTechnologyStack
  })) ?? [], [techModalData]);

  const title = 'Select additional technologies this product license will cover'

  const onAddClick = async (e) => {
    e.stopPropagation();
    setIsAdding(true);
    const payload = {
      ObjectId: integration?.integrationId,
      IntegrationTechList: selectedTechnologies,
      Selected: true,
      ToolName: integration?.integrationName,
      customerId: integration?.customerId,
    };
    // const response = await createMultipleIntegrationTechTool(payload);
    setIsAdding(false);
    // if (!response?.mr?.Success) return;
    onAddSuccess(techModalData?.filter(obj =>
      selectedTechnologies?.includes(obj?.IntegrationTechnologyTypeEnum)
    ));
    // setShowTooltip(false);
    onClose();
  }

  useEffect(() => {
    if (selected?.length > 0) {
      const selectedEnums = techModalData
        ?.filter(item1 =>
          selected?.some(
            item2 => item2?.IntegrationTechnologyTypeEnum === item1?.IntegrationTechnologyTypeEnum
          )
        )
        ?.map(item => item?.IntegrationTechnologyTypeEnum);
    
      setSelectedTechnologies(selectedEnums)
    }
  }, [selected])

  const onDismissClick = (e) => {
    e.stopPropagation();
    setShowTooltip(false);
    onClose();
  }

  const onReviewClick = (e) => {
    e.stopPropagation();
    setIsReviewing(true);
  }

  useEffect(() => {
    if (!showTooltip) {
      setTimeout(() => {
        setIsReviewing(false);
        setSelectedTechnologies([]);
      }, delay);
    }
  }, [showTooltip]);

  return (
    <div className={cn("review-more-tools-tooltip", className)}>
      <div className="arrow" />
      <div className="inner-body" onClick={e => e.stopPropagation()}>
        <div className="d-flex" style={{ gap: '4px' }}>
          <div className='lump-icon'>
            <LumpIcon
              style={{
                minWidth: '10px',
                minHeight: '14px',
              }}
            />
          </div>
          <div className="d-flex flex-column w-100" style={{ gap: '8px' }}>
            <p className='f-white m-0'>
              {title}
            </p>
            {isReviewing && (
              <div className='d-flex flex-column' style={{ gap: '4px' }}>
                <h4 className='m-0 review-title'>
                  Choose technologies:
                </h4>
                <div>
                {list
                ?.sort((a, b) => Number(b?.inYourStack) - Number(a?.inYourStack))
                ?.map((item, index) => (
                  <RowItem 
                    key={`${item?.label}-${item?.enum}-${index}`}
                    item={item}
                    index={index}
                    selectedTechnologies={selectedTechnologies}
                    setSelectedTechnologies={setSelectedTechnologies}
                  />
                ))}
                </div>
              </div>
            )}
            <div className="d-flex justify-content-end" style={{ gap: '10px' }}>
              <button
                onClick={onDismissClick}
              >
                Dismiss
              </button>
              {isReviewing ? (
                <button 
                  className='review-btn'
                  onClick={onAddClick}
                  disabled={isAdding}
               >
                  <span style={{ padding: '1px 4px' }}>
                    Add
                  </span>
                  {isAdding && (
                    <Spinner
                      className='mr-1'
                      animation="border"
                      variant="light"
                      size="sm"
                      style={{
                        width: "12px",
                        height: "12px",
                      }}
                    />
                  )}
               </button>
              ) : (
                <button 
                  className='review-btn'
                  onClick={onReviewClick}
                >
                  Review
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReviewMoreToolsTooltip;

const RowItem = ({ item, index, setSelectedTechnologies, selectedTechnologies }) => {
  const isChecked = selectedTechnologies?.includes(item?.enum);
  return (
    <div 
      className={`d-flex align-items-center tech-item ${item?.inYourStack ? 'in-your-stack' : ''}`} 
      style={{ gap: '8px' }}
    >
      <div className='d-flex'>
      <Form.Group className="fixed-checkbox blue-checkbox pointer-checkbox">
        <Form.Check 
          type="checkbox"
          onChange={e => {
            e.stopPropagation();
            if (item.inYourStack) return;
            if (e.target.checked) {
              setSelectedTechnologies([...selectedTechnologies, item?.enum]);
            } else {
              setSelectedTechnologies(selectedTechnologies.filter(tech => tech !== item?.enum));
            }
          }}
          checked={isChecked}
          id={`cb-${index}`}
          className="checkbox"
          {...(item.inYourStack ? {
            checked: true,
          } : {})} 
        />
      </Form.Group>
      </div>
      <label className={`m-0 ${!item?.inYourStack ? 'pointer' : ''}`} htmlFor={`cb-${index}`}>
        {item?.label} {item?.inYourStack ? '(in your stack)' : ''}
      </label>
    </div>
  )
}
